import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class ContributionApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('contribution'), options);
  }

  public getStateMachine(contributionType: string) {
    if (!contributionType) {
      const error = {
        message: 'Missing parameter: contributionType',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/contribution/v1/statemachine/${contributionType}`;
    return this.get(query);
  }

  public createContribution(contribution: any) {
    const query = '/contribution/v1/contribution';
    if (!contribution) {
      const error = {
        message: 'Missing parameter: contribution',
        name: 'bad parameter',
      };
      throw error;
    }
    return this.post(query, { data: contribution });
  }

  public updateStatus(contributionId: number, status: any) {
    if (!contributionId) {
      const error = {
        message: 'Missing parameter: contributionId',
        name: 'bad parameter',
      };
      throw error;
    }
    if (!status) {
      const error = {
        message: 'Missing parameter: status',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/contribution/v1/contribution/${contributionId}/status`;

    return this.put(query, { data: status.id });
  }

  public submitFields(contributionId: number, fields: any) {
    if (!contributionId) {
      const error = {
        message: 'Missing parameter: contributionId',
        name: 'bad parameter',
      };
      throw error;
    }
    if (!fields) {
      const error = {
        message: 'Missing parameter: fields',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/contribution/v1/contribution/${contributionId}/submit`;

    return this.post(query, { data: fields });
  }

  public acceptReview(contributionId: number, data: any) {
    if (!contributionId) {
      const error = {
        message: 'Missing parameter: contributionId',
        name: 'bad parameter',
      };
      throw error;
    }
    if (!data) {
      const error = {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/contribution/v1/contribution/${contributionId}/accept`;

    return this.post(query, { fields: data });
  }

  public refuseReview(contributionId: string, data: any) {
    if (!contributionId) {
      const error = {
        message: 'Missing parameter: contributionId',
        name: 'bad parameter',
      };
      throw error;
    }
    if (!data) {
      const error = {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/contribution/v1/contribution/${contributionId}/refuse`;

    return this.post(query, { fields: data });
  }
}
